<script setup>
    /**
     * Vue Scripts
     */
    import {ref} from "vue";
    import {globalStore} from "@pinia/global-store";
    import {handlePredictiveUrl, setPredictiveResult} from "@util/api";

    /**
     * Vue Components
     */
    import PredictiveDropdown from "@component/PredictiveDropdown/PredictiveDropdown.vue";
    import SearchButton from "@component/SearchButton/SearchButton.vue";

    const {predictiveApi} = API;
    const {
        noResults,
        searchTitle,
        searchBtn,
        searchCta,
        searchPlaceholder
    } = TRIAL_SEARCH
    const {isHcps} = GLOBAL;

    const searchUrl = searchCta?.url || '';

    const searchedItem = ref({});
    /**
     * Take the user directly to the page if it is a generated
     * result, or take the user to the Search page if it is
     * a search term
     *
     * @param {Object} data The selected item searched for
     */
    const goToLink = (data) => {
        searchedItem.value = data
        handlePredictiveUrl(data, searchUrl)
    }

</script>

<template>
    <form id="trial-search"
          ref="antidoteForm"
          :action="searchUrl"
          class="predictive-search-form">
        <div class="form-header">
            <label for="vue-search-trials"
                   v-text="searchTitle" />
        </div>
        <div class="form-body">
            <PredictiveDropdown
                id="vue-search-trials"
                label="name"

                :api="predictiveApi"
                :isHcps="isHcps"
                :placeholder="searchPlaceholder"
                :noResults="noResults"

                @getResult="goToLink"
            />
            <SearchButton
                :button-text="searchBtn"
                @clickAction="setPredictiveResult(searchedItem, searchUrl)"
            />
        </div>
    </form>
</template>

<script>
    export default {
        name: "Trial Search"
    }
</script>

<style scoped lang="scss">

</style>
